<template>
  <div id="app" @click="lisenceUserDo" @input="lisenceUserDo">
    <router-view />
  </div>
</template>

<script>
import { setTimeout } from "timers";
function doKey(e) {
  var ev = e || window.event; //获取event对象
  var obj = ev.target || ev.srcElement; //获取事件源
  var t = obj.type || obj.getAttribute("type"); //获取事件源类型

  if (ev.keyCode == 8 && t != "password" && t != "text" && t != "textarea") {
    return false;
  }
}
export default {
  name: "App",
  data() {
    return {
      heart: true,
      TimeOut: 60 * 1000
    };
  },
  mounted() {
    //禁止后退键 作用于Firefox、Opera
    document.onkeypress = doKey;
    //禁止后退键  作用于IE、Chrome
    document.onkeydown = doKey;

    if (localStorage.userInfo) {
      this.$store.dispatch("setUserInfo", JSON.parse(localStorage.userInfo));
    } else {
      this.$router.replace("/login");
    }
    // 本地缓存主要是防止刷新页面拿不到登录信息
    if (localStorage.loginForm) {
      this.$store.dispatch("setLoginForm", JSON.parse(localStorage.loginForm));
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  methods: {
    lisenceUserDo() {
      if (!this.userInfo) return;
      if (this.heart) {
        this.heart = false;
        this.$http.get("/gavial/v1/info/heartbeat").finally(() => {
          setTimeout(() => {
            this.heart = true;
          }, this.TimeOut);
        });
      }
    }
  }
};
</script>

<style lang="scss">
html {
  --blue: #3b91ec;
  --red: #d75452;
  --green: #5fb760;
  --padding: 8px;
  --paddingf: -8px;
}

body [class^="el-icon-ga-"],
body [class*="el-icon-ga-"] {
  font-family: "iconfont" !important;
}

#app {
  height: 100vh;
  width: 100vw;
  background: #f0f2f5;
  overflow: hidden;
}
</style>
